// extracted by mini-css-extract-plugin
module.exports = {"rules":"_1uLfospr2wZH4GyGXzc4fy"};